// Lucide icon: chevrons-right (https://lucide.dev/icons/chevrons-right)
import { ChevronsRight } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconChevronDoubleRight = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ChevronsRight />
    </IconComponentStyled>
  )
}
